<kendo-dropdownlist
  class="item-list"
  textField="name"
  valueField="id"
  [kendoDropDownFilter]="filterSettings"
  [popupSettings]="popupSettings"
  [loading]="$isLoading()"
  [data]="$all()"
  [value]="$defaultItem()"
  (valueChange)="changeSelectedValue($event)">
  <ng-template let-dataItem kendoDropDownListItemTemplate>
    <kendo-stacklayout class="item-stack" orientation="vertical">
      <div class="item-main">
        {{ dataItem.name }}
        <unity-chip-workflow-state-shared
          class="status-chip"
          size="small"
          [name]="dataItem.current_state.name"
          [value]="dataItem.current_state.enum_value" />
      </div>
      <div>{{ dataItem.program.name }}</div>
      <div>{{ dataItem.start_date | dateTimezone: 'LLL dd y' }} - {{ dataItem.end_date | dateTimezone: 'LLL dd y' }}</div>
    </kendo-stacklayout>
  </ng-template>
  <ng-template kendoDropDownListNoDataTemplate>
    <h6>No assigned agreements.</h6>
  </ng-template>
  <ng-template let-dataItem kendoDropDownListValueTemplate>
    {{ dataItem?.name }}
  </ng-template>
  <ng-template kendoDropDownListFooterTemplate>
    <button kendoButton class="view-all-button" type="button" themeColor="light" fileMode="flat" (click)="navitateToAgreementList()">
      View All
    </button>
  </ng-template>
</kendo-dropdownlist>
